<template>
    <div class="pane1">
        <div class="pane1-left">
            <div class="common-header">
                <el-input
                        size="small"
                        placeholder="请输入联盟昵称或ID查询"
                        v-model="searchUnionId"/>
            </div>
            <el-radio-group
                    class="pane1-radios common-scroll"
                    v-model="searchKey"
                    @change="getList()">
                <el-radio label="">所有俱乐部</el-radio>
                <el-radio label="allSelected">渠道分配的俱乐部</el-radio>
                <el-collapse value="1">
                    <el-collapse-item title="所有联盟" name="1">
                        <el-radio
                                v-for="item of unionList"
                                :key="item.id"
                                :label="item.id">
                            {{item.tribeName}}(ID:{{item.randomId}})
                        </el-radio>
                    </el-collapse-item>
                </el-collapse>
            </el-radio-group>
        </div>
        <div class="pane1-right">
            <div class="common-header">
                <el-input
                        v-model="searchClubId"
                        size="small"
                        class="common-el-input-small"
                        placeholder="请输入俱乐部ID查询"/>
                <el-button size="small" type="primary" @click="getList()">搜索</el-button>
                <div class="common-header-right">
                    <el-button size="small" type="primary" @click="saveSelect()">保存</el-button>
                </div>
            </div>
            <div class="common-table" style="min-height: auto">
                <el-table
                        ref="channelClubTable"
                        v-loading="loading"
                        :data="channelClubList.beanList"
                        height="100%"
                        row-key="id"
                        @selection-change="selectionVal = $event">
                    <!--<template slot="empty">该俱乐部已经配置于XXX代充渠道，渠道ID：XXX</template>-->
                    <el-table-column type="selection"/>
                    <el-table-column type="index" label="编号" width="55" align="center"/>
                    <el-table-column label="俱乐部昵称" align="center" prop="clubName"/>
                    <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                    <el-table-column label="交易模式" align="center" prop="transType">
                        <template slot-scope="scope">{{scope.row.transType | topUpTypeName}}</template>
                    </el-table-column>
                    <template v-if="searchKey === ''||searchKey==='allSelected'">
                        <el-table-column label="联盟昵称" align="center" prop="tribeName"/>
                        <el-table-column label="联盟ID" align="center" prop="tribeId"/>
                    </template>
                </el-table>
            </div>
            <el-pagination
                    class="common-el-pagination"
                    layout="prev,pager,next,jumper"
                    background
                    :page-size="10"
                    :pager-count="5"
                    :total="channelClubList.total"
                    :current-page="currentPage"
                    @current-change="currentChange($event)"/>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            info: Object
        },
        data() {
            return {
                loading: false,
                searchKey: '',
                selectionVal: [],//选中的俱乐部
                searchUnionId: '',
                searchClubId: '',
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('union', ['allUnionList']),
            ...mapState('payChannel', ['channelClubList']),
            unionList() {
                if (this.searchUnionId) {
                    let reg = new RegExp(this.searchUnionId);
                    return this.allUnionList.filter(item => {
                        if (reg.test(item.tribeName) || reg.test(item.randomId)) {
                            return true
                        }
                    })
                }
                return this.allUnionList
            }
        },
        watch: {
            info() {
                this.getList();
            }
        },
        methods: {
            ...mapActions('payChannel', ['getChannelClubList', 'getChannelUnSelectClubList', 'addChannelClub']),
            getList(page = 1) {
                this.currentPage = page;
                this.loading = true;
                if (this.searchKey === 'allSelected') {
                    // 获取该渠道下的俱乐部
                    this.getChannelClubList({
                        channelId: this.info.id,
                        search: this.searchClubId,
                        page,
                        size: 10
                    }).then(() => {
                        this.selectionRow();
                        this.loading = false;
                        if(!this.channelClubList.beanList.length && page !== 1){
                            this.getList(this.currentPage - 1)
                        }
                    })
                } else {
                    this.getChannelUnSelectClubList({
                        channelId: this.info.id,
                        search: this.searchClubId,
                        tribeId: this.searchKey,
                        page,
                        size: 10
                    }).then(() => {
                        this.selectionRow();
                        this.loading = false;
                    })
                }
            },
            selectionRow() {
                this.channelClubList.beanList.forEach((item, index) => {
                    if (item.isSelected) {
                        this.$refs.channelClubTable.toggleRowSelection(this.channelClubList.beanList[index])
                    }
                });
            },
            currentChange(page){
                let newSelectClubIds = this.selectionVal.map(item => item.id);
                let oldSelectClubIds = this.channelClubList.beanList.filter(item => item.isSelected).map(item => item.id);
                let diff = false;
                if (newSelectClubIds.length !== oldSelectClubIds.length) {
                    diff = true;
                } else {
                    oldSelectClubIds.forEach(item => {
                        if (newSelectClubIds.indexOf(item) < 0) {
                            diff = true;
                        }
                    });
                }
                if (diff) {
                    this.$confirm('是否保存当前页修改', '提示', {
                        type: 'info'
                    }).then(() => {
                        this.saveSelect(page);
                    }).catch(() => {
                    });
                }else{
                    this.getList(page)
                }
            },
            // 保存俱乐部配置
            saveSelect(page = null) {
                this.loading = true;
                let selectClubIds = this.selectionVal.map(item => item.id);
                let UnSelectClubIds = this.channelClubList.beanList.filter(item => {
                    return selectClubIds.indexOf(item.id) < 0
                }).map(item => item.id);
                this.addChannelClub({
                    payChannelId: this.info.id,
                    selectClubIds,
                    UnSelectClubIds
                }).then(() => {
                    this.loading = false;
                    this.$message.success('保存成功');
                    if (page) {
                        // 翻页保存时 请求列表
                        this.getList(page);
                    }else{
                        // 保存当前页 更新列表
                        this.getList(this.currentPage);
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>

    .pane1 {
        display: flex;
        //width:808px;
        :global(.el-collapse){
            margin-top: 15px;
        }
        :global(.el-collapse-item__header){
            padding-left: 10px;
            border: 0;
        }
        :global(.el-collapse-item__wrap){
            border: 0;
        }
        &-left {
            width: 230px;
            height: 430px;
            padding-right: 10px;
            margin-right: 10px;
            border-right: 2px solid $border-color;
            box-sizing: border-box;
        }
        &-right {
            display: flex;
            flex-flow: column;
            width: 808px - 240;
            height: 430px;
        }
        .common-header-right {
            margin-top: 0;
        }
        .common-el-pagination {
            padding-top: 10px !important;
        }
        &-radios {
            display: block;
            height: 380px;
            margin-top: 10px;
            overflow-y: scroll;
            :global(.el-radio) {
                display: block;
                margin-top: 15px;
            }
            :global(.el-radio__input) {
                position: absolute;
                opacity: 0;
            }
        }
    }
</style>